import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import TrashRow from "./TrashRow";
import TrashAll from "./TrashAll";

export default function DenseTable({ cartData, columns, display, uid }) {
  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            {columns.map((column, i) => (
              <TableCell key={i}>{display[column]}</TableCell>
            ))}
            <TableCell>
              <TrashAll></TrashAll>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cartData.map((datum, j) => {
            const rowKey = `${datum[uid]}-cart-row-${j}`;
            return (
              <TableRow
                key={rowKey}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:nth-of-type(odd)": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                {columns.map((column, i) => {
                  const columnKey = `${datum[uid]}-cart-col-${i}row-${j}`;
                  return <TableCell key={columnKey}>{datum[column]}</TableCell>;
                })}

                <TableCell>
                  <TrashRow uid={datum[uid]}></TrashRow>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
